<template>
  <div></div>
</template>

<script>
import AuthUser from "@/services/api/authUser";
export default {
  created() {
    AuthUser.logout();
    this.$router.push("/login");
  }
}
</script>

<style>

</style>
